import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeedHiddenItemsDialogComponent } from './feed-hidden-items-dialog.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from '@app/material.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [FeedHiddenItemsDialogComponent],
  imports: [CommonModule, MaterialModule, FlexLayoutModule, TranslateModule],
  exports: [FeedHiddenItemsDialogComponent],
})
export class FeedHiddenItemsDialogModule {}
